import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

function EmployeeCategorySideScroll({ employeeCategories, viewEmployeeCategoryDetails }) {
  const { id } = useParams();
  const selectedCardRef = useRef(null);

  useEffect(() => {
    selectedCardRef.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }, [id, employeeCategories.length]);

  return (
    <div className="w-full h-screen p-2 border-[1px] border-gray-200 rounded-lg overflow-y-auto scrollbar-thumb-gray-400 scrollbar-thin scrollbar-track-gray-200">
      {employeeCategories.map((employeeCategory, index) => {
        const selected = String(id) === String(employeeCategory.id);
        return (
          <div
            ref={selected ? selectedCardRef : null}
            className={twMerge(
              "border px-2 py-3 cursor-pointer border-gray-200 transition-colors",
              selected ? "bg-gray-200" : "hover:bg-gray-100"
            )}
            key={employeeCategory.id || index}
            onClick={() => viewEmployeeCategoryDetails(employeeCategory.id)}
          >
            <div className="text-sm font-semibold text-gray-700 truncate">
              {employeeCategory.name}
            </div>
            <div className="mt-1 text-xs font-medium text-gray-500">
              {employeeCategory.statusName}
            </div>
          </div>
        );
      })}
      {employeeCategories.length < 1 ? (
        <div className="p-4 text-sm text-gray-500">No Employee Categories found</div>
      ) : null}
    </div>
  );
}

export default EmployeeCategorySideScroll;
